import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom'

import { Fire, Tools, Time } from '../../../services'

import { Headerbar, FormInput, OnOff, ConfirmLink, ClickToCopy, YesNo, Loader, EditContainer, ImagesPicker, Select } from '../../Reusable'

import FadeIn from 'react-fade-in';

import DatePicker from 'react-date-picker'
import TimePicker from 'rc-time-picker';

import 'rc-time-picker/assets/index.css';
import './MyDateTimePicker.scss'

const { useHistory } = require('react-router-dom')

interface Props {
  dateTitle?: string;
  timeTitle?: string;

  date?: Date;
  disabled?: boolean;
  spaceBetween?: boolean;
  hideTime?: boolean;

  error?: string;
  onChange: (date: Date) => void;
}
const MyDateTimePicker: React.FC<Props> = (props) => {
  const date = props.date || new Date()
  const error = props.error
  const hideTime = props.hideTime

  const onChangeDate = (value: any) => {
    const hours = date.getHours()
    const minutes = date.getMinutes()
    const newDate = new Date(value)
    newDate.setHours(hours)
    newDate.setMinutes(minutes)
    props.onChange(newDate)
  }

  const onChangeTime = (value: any) => {
    const newDate = new Date(value)
    date.setHours(newDate.getHours())
    date.setMinutes(newDate.getMinutes())
    props.onChange(date)
  }

  return (
    <div className="date-pickers" style={{justifyContent: props.spaceBetween ? 'space-between' :  'flex-start'}}>
      <div className="date-picker">
        <div className="date-label">
          <span>{props.dateTitle || 'Sélectionner une date'}</span>
          {error ? (
           <span className="date-error">{error}</span>
          ) : (null)}
        </div>
        <div>
          <DatePicker
            minDate={new Date()}
            clearIcon={null}
            disabled={props.disabled}
            className={error ? "error" : undefined}
            value={date}
            onChange={(value: any) => onChangeDate(value)}
          />
        </div>
      </div>

      { !hideTime &&
        <div className="date-picker" style={{ marginLeft: props.spaceBetween ? 0 : 20 }}>
          <div className="date-label">{props.timeTitle || ''}</div> 
          <div>
            <TimePicker
              disabled={props.disabled}
              showSecond={false}
              value={Time.moment(date)}
              className={error ? "error" : undefined}
              onChange={(value: any) => onChangeTime(value)}
              format={'HH:mm'}
              inputReadOnly
            />
          </div>
        </div>
      }
    </div>
  )
}

export default MyDateTimePicker
